import { Link } from "react-router-dom"

import style from "modules/PsyProfile/components/Breadcrumbs/style.module.scss"
import { Psychologist } from "utils/interfaces"
import { APP_PAGE_URL } from "utils/env-management"

export function Breadcrumbs({ psy }: { psy: Psychologist }) {
    return (
        <section className={style.container} data-testid="psy-profile-breadcrumbs">
            <nav aria-label="breadcrumb">
                <ol className={style.list} itemScope itemType="https://schema.org/BreadcrumbList">
                    <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                        <a
                            href={APP_PAGE_URL}
                            data-testid="psy-profile-breadcrumbs-main"
                            itemProp="item"
                        >
                            <span itemProp="name">Главная</span>
                        </a>
                    </li>
                    <span>&middot;</span>
                    <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                        <Link
                            to="/psychologists"
                            data-testid="psy-profile-breadcrumbs-catalog"
                            itemProp="item"
                        >
                            <span itemProp="name">Каталог психологов</span>
                        </Link>
                    </li>
                    <span>&middot;</span>

                    <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                        <Link
                            to={`/psychologists/${psy.new_city.slug}`}
                            data-testid="psy-profile-breadcrumbs-city"
                            itemProp="item"
                        >
                            <span itemProp="name">{psy.new_city.name}</span>
                        </Link>
                    </li>
                </ol>
            </nav>
        </section>
    )
}
